export interface EquipmentDef {
  id: string;
  name: string;
  description: string;
}

export const EQUIPMENT_DEFS: EquipmentDef[] = [
  { id: 'rod', name: 'Fishing Rod', description: '+11.2% catch weight, +7% catch speed at Lv.2, diminishing per level' },
  { id: 'bait', name: 'Bait', description: '+8.4% rare fish chance at Lv.2, diminishing returns per level' },
  { id: 'line', name: 'Fishing Line', description: '+7% max fish weight at Lv.2, diminishing returns per level' },
  { id: 'boat', name: 'Boat', description: 'Upgrade to reach distant fishing locations.' },
];

export function getEquipmentDefById(id: string): EquipmentDef | undefined {
  return EQUIPMENT_DEFS.find(e => e.id === id);
}

const BOAT_TIER_NAMES = ['', 'Rowboat', 'Skiff', 'Trawler', 'Schooner', 'Frigate'];
const BOAT_UPGRADE_COSTS = [0, 2500, 10000, 50000, 750000, 10000000];

export function getBoatTierName(level: number): string {
  if (level < 1 || level >= BOAT_TIER_NAMES.length) return 'Unknown';
  return BOAT_TIER_NAMES[level];
}

export function getBoatUpgradeCost(currentLevel: number): number | null {
  if (currentLevel < 1 || currentLevel >= 5) return null;
  return BOAT_UPGRADE_COSTS[currentLevel];
}

export function getUpgradeCost(equipId: string, level: number): number {
  if (equipId === 'boat') {
    return BOAT_UPGRADE_COSTS[level] ?? 0;
  }
  return Math.floor(50 * Math.pow(level, 1.5));
}
